import React, { useState, useEffect } from "react";
import DataBarChart from "../../../common/DataBarChart/DataBarChart";
import { useGetIndividualTargetsChartDataByUserIdQuery } from "../diagramsSlice";
import LoadingSpinner from "../../../common/LoadingSpinner/LoadingSpinner";
import { selectCurrentUser } from "../../../../features/auth/authSlice";
import { useSelector } from "react-redux";

const IndividualTargetsChart = ({
  width,
  height,
  isAutomated,
  isDisabled,
  timeInterval,
  fontSize,
  margin,
}) => {
  const [type, setType] = useState("month");

  function handleChildClick(value) {
    setType(value);
  }
  const user = useSelector(selectCurrentUser);

  const {
    data: individualTargetsChartData,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetIndividualTargetsChartDataByUserIdQuery({
    userId: user.userID,
    type: type,
  });

  const [individualTargetsData, setIndividualTargetsData] = useState([]);

  useEffect(() => {
    if (individualTargetsChartData) {
      const data = individualTargetsChartData.ids.map((id) => {
        return individualTargetsChartData.entities[id];
      });
      setIndividualTargetsData(data);
    }
  }, [individualTargetsChartData, type]);

  return (
    <div className="chart-container" id="barchart-container">
      {isLoading && <LoadingSpinner />}
      {individualTargetsData.length > 0 && (
        <DataBarChart
          chartData={individualTargetsData}
          title={"Individual Sales This Month"}
          category={"individual"}
          width={width}
          height={height}
          handleFilter={handleChildClick}
          isAutomated={isAutomated}
          isDisabled={isDisabled}
          timeInterval={timeInterval}
          refetch={refetch}
          fontSize={fontSize}
          margin={margin}
        />
      )}
    </div>
  );
};

export default IndividualTargetsChart;
